<template>
  <div>
    <div class="top-bar col-md-12 m-0 p-0">
      <div
        class="m-0 p-0 py-2 col-md-12 top-nav"
        style="box-shadow: 0 2px 3px -1px rgba(0,0,0,.1)"
      >
        <div class="col-md-11 m-0 p-0 mx-auto">
          <b-navbar class="m-0 p-0">
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav>
                <b-nav-item class="m-0 p-0 my-auto" v-b-toggle.sidebar-backdrop>
                  <b-button pill variant="light">
                    <i class="fas fa-bars bars text-dark"></i>
                  </b-button>
                </b-nav-item>
                <b-nav-item
                  link-classes="m-0 p-0"
                  v-b-tooltip.hover
                  title="Go to Homepage"
                  class="my-auto m-0 p-0"
                  @click="$router.push('/')"
                >
                  <img
                    src="../../assets/logo/outreach.png"
                    alt=""
                    class="m-0 p-0"
                    width="150px"
                  />
                  <!-- <p class="m-0 p-0 my-auto logo">Outreach</p> -->
                </b-nav-item>
              </b-navbar-nav>
              <b-navbar-nav class="col-md-3 ml-auto mr-0 p-0">
                <search></search>
              </b-navbar-nav>
              <!-- Right aligned nav items -->
              <!-- <b-navbar-nav class="m-0 p-0 ml-auto">
                  <b-nav-item @click="$router.push('/feeds')" v-b-tooltip.hover title="Go to Feeds / Agent Activity">
                    <b-avatar class="text-white m-0 p-0" icon="chat-square-dots" :badge="mockEvent.length" badge-variant="success" size="sm" variant="outline-light"></b-avatar>
                  </b-nav-item>
                  <b-nav-item>
                    <b-avatar size="sm" variant="info" class="mr-3"></b-avatar>
                  </b-nav-item>
              </b-navbar-nav> -->
              <b-navbar-nav class="m-0 p-0 ml-auto">
                <!-- <b-nav-item link-classes="m-0 px-1" class="m-0 p-0" @click="$router.push('/userAgents')" v-b-tooltip.hover title="All Agents">
                    <b-avatar class="m-0 p-1" icon="person-badge" :badge="mockEvent.length > 0 ? `${mockEvent.length}` : null" badge-variant="danger" size="md" variant="light"></b-avatar>
                  </b-nav-item> -->
                <b-nav-item
                  link-classes="m-0 px-1"
                  class="m-0 p-0"
                  @click="gotofeeds"
                  v-b-tooltip.hover
                  title="Feeds / Agent Activity"
                >
                  <b-avatar
                    class="m-0 p-1"
                    icon="layout-text-window"
                    :badge="mockEvent.length > 0 ? `${mockEvent.length}` : null"
                    badge-variant="warning"
                    size="md"
                    variant="light"
                  ></b-avatar>
                </b-nav-item>
                <b-nav-item
                  link-classes="m-0 px-1"
                  class="m-0 p-0"
                  @click="$router.push('/user/agent/profile')"
                  v-b-tooltip.hover
                  title="Your profile"
                >
                  <b-avatar
                    class="m-0 p-1"
                    icon="person"
                    size="md"
                    variant="light"
                  ></b-avatar>
                </b-nav-item>

                <!-- <b-nav-item link-classes="m-0 px-1" class="m-0 p-0" v-b-tooltip.hover title="Profile">
                    <b-avatar class="m-0 p-1" icon="person" :badge="mockEvent.length > 0 ? `${mockEvent.length}` : null" badge-variant="success" size="md" variant="light"></b-avatar>
                  </b-nav-item> -->
                <b-nav-item
                  link-classes="m-0 px-1"
                  class="m-0 p-0"
                  @click="logout"
                  v-b-tooltip.hover
                  title="Logout"
                >
                  <b-button pill variant="light">
                    <b-icon icon="power"></b-icon> Logout</b-button
                  >
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
      <div class="shadow-sm col-md-12 m-0 p-0 bg-white">
        <div class="col-md-11 mx-auto m-0 p-0">
          <b-navbar class="m-0 p-0 py-2">
            <b-navbar-nav>
              <b-nav-item-dropdown
                v-for="(data, index) in navs"
                :key="index"
                :text="data.heading"
                left
                class="my-auto mr-4 m-0 p-0"
              >
                <b-dropdown-item
                  v-for="(nav, index) in data.subCategories"
                  :key="index"
                  @click="$router.push(nav.redirectLink)"
                  >{{ nav.heading }}
                  <b-badge v-if="nav.new" variant="danger">New</b-badge>
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-navbar>
        </div>
      </div>
    </div>

    <div>
      <b-sidebar
        id="sidebar-backdrop"
        title="Ontrack Outreach"
        shadow
        width="20%"
        backdrop
      >
        <template #title>
          <!-- <p class="m-0 p-0">Ontrack Outreach</p>
          <p class="m-0 p-0" style="font-size:10px;color:gray">
            Powered by Ontrack
          </p> -->
          <img
            src="../../assets/logo/outreach_black.png"
            alt=""
            class="m-0 p-0"
            width="150px"
          />
        </template>
        <template>
          <div class="p-3">
            <nav
              class="submenu2 py-2"
              @click="$router.push('/')"
              style="cursor:pointer;font-size:14px"
            >
              <i class="fal fa-home"></i> Homepage
            </nav>
            <nav class="m-0 p-0">
              <b-nav vertical>
                <div
                  v-for="(data, index) in navs"
                  :key="index"
                  class="text-left m-0 p-0 py-2 col-12"
                >
                  <div class="heading pb-2">
                    <p class="strong m-0 p-0">
                      <b-icon
                        class=""
                        variant="secondary"
                        :icon="data.icon"
                      ></b-icon>
                      {{ data.heading }}
                    </p>
                  </div>
                  <div
                    class=""
                    v-for="(nav, index) in data.subCategories"
                    :key="index"
                  >
                    <!-- <p class="btn-link">{{nav.heading}}</p> -->
                    <router-link
                      class="submenu"
                      exact-active-class="nav-active"
                      :to="nav.redirectLink"
                    >
                      <div
                        class="col-md-12 submenu py-1"
                        style="border-left:1px solid #DADBDB"
                      >
                        <b-icon
                          v-if="!nav.iconStack"
                          :icon="nav.icon"
                          class="iconss"
                          variant="secondary"
                        ></b-icon>
                        <b-iconstack class="iconss" v-else font-scale="1">
                          <b-icon
                            variant="secondary"
                            class="iconss"
                            stacked
                            icon="square"
                          ></b-icon>
                          <b-icon
                            variant="secondary"
                            class="iconss"
                            stacked
                            icon="bar-chart-fill"
                            scale="0.8"
                            flip-h
                            rotate="-90"
                          ></b-icon>
                        </b-iconstack>
                        {{ nav.heading }}
                        <b-badge
                          v-if="nav.new"
                          style="font-size:10px"
                          class="m-0 p-0 p-1"
                          variant="danger"
                          >New</b-badge
                        >
                      </div>
                    </router-link>
                  </div>
                </div>
              </b-nav>
            </nav>
            <p class="m-0 p-0 pt-4" style="font-size:12px;color:gray">
              Made with <b-icon icon="heart-fill" variant="danger"></b-icon> by
              Ontrack Lab
            </p>
            <div class="col-md-12 text-left m-0 p-0">
              <p
                @click="$router.push('/releaseNote')"
                style="font-size:14px;color:gray"
                class="btn btn-link text-left m-0 p-0"
              >
                version 8.0.1
              </p>
            </div>
          </div>
        </template>
      </b-sidebar>
    </div>
    <div class="col-md-11 col-12 m-auto contains m-0 p-0 py-4">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import navs from "../../Inventory/navs.json";
import search from "../rental/customer/search.vue";
import Pusher from "pusher-js";

export default {
  data() {
    return {
      navs: navs,
      search: false,
      searchItem: "",
      mockEvent: [],
    };
  },
  components: {
    search,
  },
  created() {
    this.subscribe();
  },
  methods: {
    gotofeeds() {
      this.mockEvent = [];
      this.$router.push("/feeds");
    },
    subscribe() {
      let pusher = new Pusher("0e8ada63fd76745744a1", { cluster: "ap2" });
      let pusherOnline = new Pusher("ee806d4a079de211aee2", { cluster: "ap2" });
      pusher.subscribe("my-channel");
      pusher.bind("my-event", (data) => {
        this.mockEvent.push(data.message);
        this.showNotification(data.message);
      });
      pusherOnline.subscribe("my-channel");
      pusherOnline.bind("my-event", (data) => {
        this.$toasted.show(data.message, { type: "success" }).goAway(1000);
      });
    },
    showNotification(message) {
      // check for permission
      Notification.requestPermission().then((x) => {
        console.log(x);
        if (x == "granted") {
          // if granted
          return new Notification(message); // send push notification
        } else if (x == "denied") {
          console.log("denied");
          // if denied do something
        } else if (x == "default") {
          // if default do something
          console.log("default");
        }
      });
    },
    hideSearch() {
      this.search = false;
    },
    searchLinkRedirect(link) {
      this.search = false;
      this.$router.push(link);
    },
    logout() {
      this.$store.dispatch("switchUser", {
        online: 0,
        notify: true,
      });
      localStorage.removeItem("userData");
      localStorage.removeItem("agentToken");
      this.$router.push("/login");
    },
    searchToggler() {
      this.search = !this.search;
    },
  },
  computed: {
    username() {
      return this.$store.getters.userName || "Anonymous";
    },
    filterName() {
      return this.navs.filter((x) => {
        return x.keywords.toLowerCase().includes(this.searchItem.toLowerCase());
      });
    },
    filterJSON() {
      return this.filterName.slice(0, 2);
    },
  },
};
</script>
<style scoped>
.nav-active .submenu {
  background-color: #5b35d8;
  border-radius: 10px;
  text-decoration: none;
  color: white;
}
.nav-active .submenu .iconss {
  color: white !important;
}
.submenu {
  color: black;
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
}
.submenu:hover {
  background-color: rgba(150, 145, 167, 0.1);
  border-radius: 10px;
  text-decoration: none;
  font-weight: bold;
  color: #5b35d8 !important;
}
.submenu2:hover {
  border-radius: 10px;
  text-decoration: none;
  font-weight: bold;
  color: #5b35d8 !important;
}

.heading {
  color: gray;
  font-size: 12px;
}
.contains {
  min-height: 90vh;
}
.search-items {
  background: white;
  z-index: 99999999;
  position: absolute;
  bottom: 0;
  top: 50px;
  right: 80px;
}
.search-item-container {
  border-radius: 5px;
  border: 1px solid rgb(214, 211, 211);
  background: white;
}
.links {
  cursor: pointer;
  color: gray;
}
.links:hover {
  background: whitesmoke;
  color: black;
}
.hide {
  visibility: hidden;
}
.bars {
  color: white;
}
.top-nav {
  background: #32386b;
}
.logo {
  font-size: 30px;
  color: white;
}
</style>
